var scope_0 = require('/Users/tzachyarimi/projects/faintlines/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0ad3cab0ad332abde56960869c16d34a.js').default;
var scope_1 = require('/Users/tzachyarimi/projects/faintlines/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/80aa0e9ccb2abbbf38867e89094f198f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    